// removed by extract-text-webpack-plugin
module.exports = {"buttonGroup":"ButtonGroup__buttonGroup","noBorderRight":"ButtonGroup__noBorderRight","btn":"ButtonGroup__btn","btnBlack":"ButtonGroup__btnBlack","btnBlackHover":"ButtonGroup__btnBlackHover","btnCobalt":"ButtonGroup__btnCobalt","btnCobaltHover":"ButtonGroup__btnCobaltHover","btnWhiteHover":"ButtonGroup__btnWhiteHover","btnWhiteUnSelected":"ButtonGroup__btnWhiteUnSelected","btnWhite":"ButtonGroup__btnWhite"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ButtonGroup/ButtonGroup.scss
// module id = 1747
// module chunks = 8